import { render, staticRenderFns } from "./ActiveAccountTemplate.vue?vue&type=template&id=e874b50c&scoped=true&"
import script from "./ActiveAccountTemplate.vue?vue&type=script&lang=js&"
export * from "./ActiveAccountTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ActiveAccountTemplate.vue?vue&type=style&index=0&id=e874b50c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e874b50c",
  null
  
)

export default component.exports